export const NON_EDITABLE_CONFIGURATION_IDS = new Set(['id', 'idx', 'index', 'Alias', 'RNA_ID', 'TraceIndex', 'BWPConfigId', 'QCI']);
export const VALIDATION_FOLDER_AVAILABILITY_ERROR = 'Please, rebuild the Yang Model Collection to edit configuration';
export const VALIDATION_FOLDER_EMPTY_ERROR = 'Please select YANG model collection';
export const MAX_NOTES_LENGTH = 300;
